import React from "react";
import { Container, Typography, Box, Card, CardContent, List, ListItem, ListItemText } from "@mui/material";

export default function AboutUs() {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Card elevation={3} sx={{ p: 3, borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h4" fontWeight={700} gutterBottom>
                        About Us
                    </Typography>

                    <Typography paragraph>
                        GroomWell is a modern digital platform built to make salon experiences simple, transparent, and stress-free for both clients and salon owners. We connect people with trusted salons around them, offer real-time appointment booking, and make it easier for salon owners to showcase their services and grow their business.
                    </Typography>

                    <Typography variant="h5" fontWeight={600} gutterBottom>
                        Our Mission
                    </Typography>
                    <Typography paragraph>
                        To bring convenience, trust, and transparency to the beauty and grooming industry by creating a seamless bridge between clients and salon professionals.
                    </Typography>

                    <Typography variant="h5" fontWeight={600} gutterBottom>
                        What We Do
                    </Typography>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                        For Clients
                    </Typography>
                    <List dense>
                        <ListItem><ListItemText primary="Discover nearby salons with real ratings and reviews" /></ListItem>
                        <ListItem><ListItemText primary="Browse services, prices, and photos" /></ListItem>
                        <ListItem><ListItemText primary="Book appointments instantly" /></ListItem>
                        <ListItem><ListItemText primary="Avoid long waiting times" /></ListItem>
                        <ListItem><ListItemText primary="Choose salons confidently based on customer experiences" /></ListItem>
                    </List>

                    <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                        For Salon Owners
                    </Typography>
                    <List dense>
                        <ListItem><ListItemText primary="Create a professional online presence" /></ListItem>
                        <ListItem><ListItemText primary="Display services, pricing, and portfolios" /></ListItem>
                        <ListItem><ListItemText primary="Manage appointments digitally" /></ListItem>
                        <ListItem><ListItemText primary="Attract new customers" /></ListItem>
                        <ListItem><ListItemText primary="Build trust through ratings and reviews" /></ListItem>
                    </List>

                    <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 2 }}>
                        Why GroomWell
                    </Typography>
                    <Typography paragraph>
                        Grooming should be effortless, organized, and accessible. Whether you're booking your next haircut or growing your salon business, GroomWell brings everyone to a single, easy-to-use platform.
                    </Typography>

                    <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 2 }}>
                        Our Vision
                    </Typography>
                    <Typography paragraph>
                        To become India’s most trusted salon booking platform where every client finds the right professional and every salon gets the digital visibility it deserves.
                    </Typography>

                    <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 2 }}>
                        Join the GroomWell Community
                    </Typography>
                    <Typography>
                        {/* Thousands of clients trust GroomWell to book their grooming sessions, and hundreds of salons rely on us to manage and grow their business online. */}
                        We’re here to make your beauty journey smoother, smarter, and better.
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
}
